import { gql } from '@apollo/client'

export const DriverDetailsFragment = gql`
  fragment DriverDetails on Driver {
    id
    primaryDriverId
    firstName
    lastName
    addressLine1
    addressLine2
    bankAccountNumber
    bankName
    bankSortCode
    courierExchangeMemberId
    city
    countryId
    driverType
    xeroCodeId
    email
    employeeReference
    endorsements
    paymentTerm
    invoiceEmail
    eoriNumber
    isActive
    deactivatedByAdmin
    isEmailInvoice
    isGenerateSeparateInvoice
    lastPaid
    licenseExpiryDate
    licenseType
    currencyId
    name
    nationalInsuranceNumber
    paymentMethodId
    postcode
    publicLiabilityExpirationDate
    startDate
    telephoneNumber
    vatCategoryId
    vatIdNumber
    swift
    xeroPurchaseCode
    currencyId
    isOnboardingCompleted
    alternativeTelephoneNumber
    bankAccountHolderName
    internationalBankAccountNumber
    subDrivers {
      firstName
      lastName
      email
      telephoneNumber
    }
    companyRegistrationNumber
    isTrackingEnabled
    isUsingInternalApp
    isEmailNotification
    isEmailNotificationForNewAvailableBookings
    isMobileAppNotification
    isMobileNotificationForNewAvailableBookings
    isMobileNotificationForHgvJobs
    isMobileNotificationForNonHgvJobs
    notificationRadiusKm
    identityUserName
    driverUserStatusMessage
    activeVehicleId
    supplierAddress {
      isAddressVerified
      partialMatch
      lastGeocodingStatus
    }
  }
`

export const DriverDetailsForSupplierFragment = gql`
  fragment DriverDetailsForSupplier on Driver {
    id
    primaryDriverId
    firstName
    lastName
    addressLine1
    addressLine2
    bankAccountNumber
    bankName
    bankSortCode
    courierExchangeMemberId
    city
    countryId
    driverType
    xeroCodeId
    email
    employeeReference
    endorsements
    paymentTerm
    invoiceEmail
    eoriNumber
    isActive
    deactivatedByAdmin
    isEmailInvoice
    isGenerateSeparateInvoice
    lastPaid
    licenseExpiryDate
    licenseType
    currencyId
    name
    nationalInsuranceNumber
    paymentMethodId
    postcode
    publicLiabilityExpirationDate
    startDate
    telephoneNumber
    vatCategoryId
    vatIdNumber
    swift
    currencyId
    isOnboardingCompleted
    isEmailNotification
    isEmailNotificationForNewAvailableBookings
    isMobileAppNotification
    isMobileNotificationForNewAvailableBookings
    isMobileNotificationForHgvJobs
    isMobileNotificationForNonHgvJobs
    alternativeTelephoneNumber
    bankAccountHolderName
    internationalBankAccountNumber
    subDrivers {
      firstName
      lastName
      email
      telephoneNumber
    }
    companyRegistrationNumber
    isTrackingEnabled
    isUsingInternalApp
    identityUserName
    driverUserStatusMessage
    activeVehicleId
    supplierAddress {
      isAddressVerified
      partialMatch
      lastGeocodingStatus
    }
  }
`

export const DriverContactDetailsFragment = gql`
  fragment DriverContactDetails on DriverContact {
    id
    name
    telephoneNumber
    email
    additionalEmails
    department
    jobRole
    driverId
  }
`

export const DriverStatusFragment = gql`
  fragment DriverStatusFields on DriverStatusDto {
    id
    status
    statusLabel
    nextAddressDate
    nextAddressETA
    etaWindowMinutes
    etaSource
    etaLastUpdatedAt
    postcode
    locationStatus
    locationStatusLabel
    stopName
    stopAddress
  }
`
